export const AMP_CLASS = 'amp'
